import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';

import { User } from './user.model';
import { AuthData } from './auth-data.model';
import * as firebase from 'firebase';
import { UIService } from '../shared/ui.service';



@Injectable()
export class AuthService {
  authChange = new Subject<boolean>();
  private isAuthenticated = false;
  private user: Observable<User>;

  constructor(private router: Router,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private uiService : UIService) {

  }

  initAuthListner() {
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.isAuthenticated = true;
        this.authChange.next(true);
        //this.router.navigate(['/process-select']);
      }
      else {
        this.authChange.next(false);
        //this.router.navigate(['/login']);
        this.isAuthenticated = false;
      }
    });
  }
  registerUser(authData: AuthData) {
  
    this.afAuth.createUserWithEmailAndPassword(authData.email, authData.password)
      .then(result => {
        console.log(result);
      
      })
      .catch(error => {
        this.uiService.showSnackbar(error.message, null, 3000, false);
       
      });
  }
  login(authData: AuthData) {
    this.afAuth.signInWithEmailAndPassword(authData.email, authData.password)
      .then(result => {
        console.log(result);
       
      })
      .catch(error => {
        this.uiService.showSnackbar(error.message, null, 3000,false);
      });
     
  }

  logout() {
    localStorage.removeItem("token")

    this.afAuth.signOut();
  
  }
   
  isAuth() {
    return this.isAuthenticated ;
  }
  isAuthToken() {
    return localStorage.getItem("token")
  }
  //private authSuccessfully() {
  //  this.isAuthenticated = true;
  //  this.authChange.next(true);
  //  this.router.navigate(['/listtrans']);
  //}

  googleLogin() { 
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.afAuth
        .signInWithPopup(provider)
        .then(res => {
          console.log(res);
          res.user.getIdToken().then((t) => {
            localStorage.setItem("token", t);
            this.router.navigate(['/process-select']);
          })
         
        })
  
  }

  private oAuthLogin(provider) {
    return this.afAuth.signInWithPopup(provider)
      .then(result => {
        console.log(result);
        
      })
      .catch(error => {
        this.uiService.showSnackbar(error.message, null, 3000,false);
      });
   
  }
  private updateUserData(user) {
    const userRef: AngularFirestoreDocument<User> = this.afs.doc('users/${user.userID}');
  }

}
